import {reqWithToken} from './requestHelper';
export async function getSys(){
    return (await reqWithToken('api/pebooking/setting/sys')).data;
}

export async function updateSys(sys){
    return (await reqWithToken('api/pebooking/setting/sys',{
        data: sys,
        method: 'put'
    })).data;
}

export async function getMonthSettings(){
    return (await reqWithToken('api/pebooking/setting/months')).data;
}

export async function insertMonth(month){
    return (await reqWithToken('api/pebooking/setting/months',{
        data: month,
        method: 'post'
    })).data;
}

export async function updateMonth(month){
    return (await reqWithToken('api/pebooking/setting/months',{
        data: month,
        method: 'put'
    })).data;
}

export async function deleteMonth(id){
    return (await reqWithToken('api/pebooking/setting/months',{
        params: {id},
        method: 'delete'
    })).data;
}

export async function insertRoom(room){
    return (await reqWithToken('api/pebooking/classrooms',{
        data: room,
        method: 'post'
    })).data;
}

export async function updateRoom(room){
    return (await reqWithToken('api/pebooking/classrooms',{
        data: room,
        method: 'put'
    })).data;
}

export async function deleteRoom(id){
    return (await reqWithToken('api/pebooking/classrooms',{
        params: {id},
        method: 'delete'
    })).data;
}

export async function getMails(){
    return (await reqWithToken('api/pebooking/setting/mails')).data;
}

export async function updateMail(mail){
    return (await reqWithToken('api/pebooking/setting/mails',{
        data: mail,
        method: 'put'
    })).data;
}

export async function getViewContent(){
    return (await reqWithToken('api/pebooking/setting/viewcontent')).data;
}

export async function updateViewContent(viewContent){
    return (await reqWithToken('api/pebooking/setting/viewcontent',{
        data: viewContent,
        method: 'put'
    })).data;
}